<template>
  <div>

    <div class="row">

      <div class="col-auto">
        <label for="select-city">Comune</label>
        <select id="select-city" name="Comune" class="custom-select" v-model="filters.city" :disabled="isLoading"
          @change="onSelectCity()">
          <option :value="undefined" key="-1">-</option>
          <option v-for="city in this.data.cities" :value="city" :key="city">
            {{ city }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <label>Azioni</label>
        <div class="btn-toolbar mr-2" role="toolbar" aria-label="Bottoni azione">
          <div class="btn-group mb-2 mr-2" role="group" aria-label="Azioni">
            <button class="btn btn-primary" @click="onSubmitFilters()" :disabled="!isFiltersSelected">
              <i class="ti ti-filter"></i> Carica
            </button>
            <button class="btn btn-default" @click="onCancelFilters()" v-if="isFiltersSelected && isPopulated">
              <i class="ti ti-arrow-circle-up"></i>
              Annulla
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="row" v-show="isPopulated && !isEmpty">
      <div class="container">

        <div id="resume-stats">
          <div class="row justify-content-center mt-3">
            <div class="col col-auto text-center m-1 p-3" style="background: #832835; color: #fff;">
              <div class="title">WIFI</div>
              <div class="subtitle">&nbsp;</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.wifi }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #8D481F; color: #fff;">
              <div class="title">PROXIMITY</div>
              <div class="subtitle">QR Code e/o sistemi di prossimità</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.proximity }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #836B13; color: #fff;">
              <div class="title">TOUCH</div>
              <div class="subtitle">Video e/o touch screen </div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.touch }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #658C33; color: #fff;">
              <div class="title">VTOUR</div>
              <div class="subtitle">Tour virtuali on-line</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.vtour }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #01AA71; color: #fff;">
              <div class="title">VLAB</div>
              <div class="subtitle">Laboratori didattici on-line</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.vlab }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #00C2C1; color: #fff;">
              <div class="title">GTOUR</div>
              <div class="subtitle">Visite guidate</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.gtour }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #00AED7; color: #fff;">
              <div class="title">GLAB</div>
              <div class="subtitle">Laboratori didattici in presenza</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.glab }}</div>
            </div>
            <div class="col col-auto text-center m-1 p-3" style="background: #0095DE; color: #fff;">
              <div class="title">TOTALE</div>
              <div class="subtitle">&nbsp;</div>
              <div class="value">{{ isLoading ? '-' : this.data.resume.total }}</div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <apexchart ref="services-chart" :height="450" :options="chart" :series="chart.series" />
          </div>
        </div>

      </div>
    </div>

    <div class="card" v-show="isPopulated">
      <vue-good-table title="Servizi" styleClass="vgt-table striped" :columns="table.columns" :rows="data.services"
        :sort-options="{ enabled: false }" :isLoading="isLoading">

        <div slot="emptystate" id="emptystate" v-if="this.data.services.length === 0">
          <div class="vgt-center-align vgt-text-disabled">
            <span v-if="!isLoading">Nessun risultato disponibile</span>
          </div>
        </div>

        <template slot="table-row" slot-scope="props">

          <div v-if="props.column.field === 'services.wifi'">
            <span v-if="props.row.services.wifi === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.wifi === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.wifi === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.proximity'">
            <span v-if="props.row.services.proximity === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.proximity === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.proximity === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.touch'">
            <span v-if="props.row.services.touch === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.touch === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.touch === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.vtour'">
            <span v-if="props.row.services.vtour === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.vtour === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.vtour === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.vlab'">
            <span v-if="props.row.services.vlab === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.vlab === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.vlab === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.gtour'">
            <span v-if="props.row.services.gtour === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.gtour === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.gtour === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

          <div v-else-if="props.column.field === 'services.glab'">
            <span v-if="props.row.services.glab === 0">
              <b style="color: #CCCCCC;">N/A</b>
              <!-- <i class="fa fa-times" style="color: #999999;"></i> -->
            </span>
            <span v-else-if="props.row.services.glab === 1">
              <i class="fa fa-times" style="color: #999999;"></i>
            </span>
            <span v-else-if="props.row.services.glab === 2">
              <i class="fa fa-check" style="color: #832835;"></i>
            </span>
          </div>

        </template>

      </vue-good-table>
    </div>

  </div>
</template>

<style lang="css">
#resume-stats .title {
  font-weight: bold;
}

#resume-stats .subtitle {
  font-size: 10px;
}

#resume-stats .value {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}
</style>

<script>
import axios from "axios";
import chartOptions from './options/chart';

export default {

  components: {

  },

  data() {
    return {

      isLoading: false,
      isPopulated: false,

      filters: {
        city: undefined
      },

      loaders: {
        services: false,
        cities: false
      },

      data: {
        resume: {},
        resume_by_types: {},
        services: [],
        cities: []
      },

      chart: {
        ...chartOptions
      },

      table: {
        columns: [
          {
            label: "NOME",
            field: "name"
          },
          {
            label: "TIPOLOGIA",
            field: "type"
          },
          {
            label: "WIFI",
            field: "services.wifi",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "PROX",
            field: "services.proximity",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "TOUCH",
            field: "services.touch",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "VTOUR",
            field: "services.vtour",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "VLAB",
            field: "services.vlab",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "GTOUR",
            field: "services.gtour",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          },
          {
            label: "GLAB",
            field: "services.glab",
            thClass: "text-center",
            tdClass: "text-center",
            width: '100px',
            html: true
          }
        ],
      }

    };
  },

  computed: {
    isFiltersSelected() {
      return (
        this.filters.city !== undefined
      );
    },
    isEmpty() {
      return (this.data.services.length === 0);
    }
  },

  methods: {

    loadData(city) {
      if (
        city === undefined
      ) return;

      const self = this;
      self.isLoading = true;

      const qs = [
        ...(city) ? ['city=' + city] : []
      ].join('&');

      axios({
        method: "get",
        url: `${self.$url}tourism/stats/services?${qs}`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.$set(self.data, "resume", response.data.resume);
          self.$set(self.data, "resume_by_types", response.data.resume_by_types);
          self.$set(self.data, "services", response.data.services);
          // console.log('loadData', self.data.resume, self.data.resume_by_types, self.data.services);
          self.updateChart();
        })
        .catch(function (error) {
          self.$processError(error);
        })
        .finally(function () {
          self.isLoading = false;
          self.isPopulated = true;
        });
    },

    loadCities() {
      const self = this;
      axios({
        method: "get",
        url: `${self.$url}tourism/stats/ui/cities`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.$set(self.data, "cities", response.data.cities);
          // console.log('loadCities', self.data.cities);
        })
        .catch(function (error) {
          self.$processError(error);
        });
    },

    onSelectCity() {
      this.$emit("input", this.filters.city);
      (!this.isFiltersSelected && !this.isEmpty)
        && this.cancelResources();
    },

    onSubmitFilters() {
      this.updateResources();
    },

    onCancelFilters() {
      this.$set(this.filters, "city", undefined);
      this.cancelResources();
    },

    updateResources() {
      this.loadData(this.filters.city);
    },

    cancelResources() {
      this.isPopulated = false;
      this.$set(this.data, "resume", {});
      this.$set(this.data, "resume_by_types", {});
      this.$set(this.data, "services", []);
      this.cancelChart();
    },

    updateChart() {
      this.$refs['services-chart'].updateOptions({
        xaxis: {
          categories: Object.keys(this.data.resume_by_types).map(type => {
            return type;
          })
        },
        series: [
          {
            name: 'Wifi',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].wifi;
            })
          },
          {
            name: 'QR Code e/o sistemi di prossimità',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].proximity;
            })
          },
          {
            name: 'Video e/o touch screen ',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].touch;
            })
          },
          {
            name: 'Tour virtuali on-line',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].vtour;
            })
          },
          {
            name: 'Laboratori didattici on-line',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].vlab;
            })
          },
          {
            name: 'Visite guidate',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].gtour;
            })
          },
          {
            name: 'Laboratori didattici in presenza',
            data: Object.keys(this.data.resume_by_types).map(type => {
              return this.data.resume_by_types[type].glab;
            })
          }
        ]
      });
    },

    cancelChart() {
      this.$refs['services-chart'].updateOptions({
        ...chartOptions
      });
    }

  },

  async created() {
    console.log('ServicesStats::created');
  },

  async mounted() {
    console.log('ServicesStats::mounted');
    this.loadCities();
  }

};
</script>
